import { actions } from './actions'

const initialState = {
  productosCaja: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosEnCajaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTOS_EN_CAJA_LOAD_REQUESTED:
      return { ...state, productosCaja: { ...state.productosCaja, loading: true } }
    case actions.PRODUCTOS_EN_CAJA_LOAD_SUCCEDED:
      return {
        ...state,
        productosCaja: { ...state.productosCaja, data: action.payload, loading: false },
      }
    case actions.PRODUCTOS_EN_CAJA_LOAD_FAILED:
      return {
        ...state,
        productosCaja: { ...state.productosCaja, loading: false, error: action.error },
      }

    default:
      return state
  }
}
